import React, { useState, useEffect } from "react";
import { t } from "i18next";
import { Spinner, Table } from "react-bootstrap";
import { ErrorToast, SuccessToast } from "../../../../shared/toasters/toasters";
import { ProductsService } from "../../service";
import { useParams } from "react-router";
import { GoogleSearchPromptService } from "../../../googleSearchPrompt/service";

export const OffcanvasAttributeLeftSide = ({
  currentProduct,
  isLoadingTable,
  setCurrentProduct,
  isCheckedAll,
  setIsCheckedAll,
  inputValues,
  setInputValues,
  checkedValues,
  setCheckedValues,
}: any) => {
  const { id, productId } = useParams();
  const [triggerNewValues, setTriggerNewValues] = useState(false);

  useEffect(() => {
    if (currentProduct?.enrichmentData?.formBuilderAttributesData) {
      const newInputValues: { [key: number]: string } = {};
      const newCheckedValues: { [key: number]: boolean } = {};

      currentProduct.enrichmentData.formBuilderAttributesData.forEach(
        (item: any, index: number) => {
          newInputValues[index] =
            item?.gptValues?.map((obj: any) => obj.title).join(", ") || "";
          newCheckedValues[index] = false;
        }
      );

      setInputValues(newInputValues);
      setCheckedValues(newCheckedValues);
    }
  }, [currentProduct, triggerNewValues]);

  const updateNewAttributeValues = (index: number, inputValue: string) => {
    setInputValues((prev: any) => ({
      ...prev,
      [index]: inputValue,
    }));

    // setCurrentProduct((prev: any) => ({
    //   ...prev,
    //   enrichmentData: {
    //     ...prev?.enrichmentData,
    //     formBuilderAttributesData:
    //       prev?.enrichmentData?.formBuilderAttributesData?.map(
    //         (item: any, i: number) => {
    //           if (i === index) {
    //             return {
    //               ...item,

    //               newValue: inputValue,
    //             };
    //           }
    //           return item;
    //         }
    //       ),
    //   },
    // }));
  };
  const handleTestClick = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    const newAttributesArray = (
      currentProduct as any
    )?.enrichmentData?.formBuilderAttributesData?.map(
      (item: any, index: number) => ({
        attributeId: item?.id,
        value: inputValues[index],
      })
    );
    GoogleSearchPromptService.enrichProductAttributeData(Number(productId), {
      attributes: newAttributesArray,
    })
      .then((response) => {
        SuccessToast(`${t("toasts.successfully_saved")}`);
        setCurrentProduct((prev: any) => ({
          ...prev,
          enrichmentData: response,
        }));
        setTriggerNewValues((prev: boolean) => !prev);
      })
      .catch((error) => ErrorToast(error));
  };

  const checkAll = (e: any) => {
    const checked = e.target.checked;
    setIsCheckedAll(checked);

    setCheckedValues((prev: any) => {
      const updated: { [key: number]: boolean } = {};
      Object.keys(prev).forEach((key) => {
        updated[Number(key)] = checked;
      });
      return updated;
    });
  };

  const checkAllFields = () => {
    let counter = 0;
    (currentProduct as any)?.enrichmentData?.formBuilderAttributesData?.map(
      (item: any, index: number) => {
        if (item?.insert === true) {
          counter = counter + 1;
        } else {
          return setIsCheckedAll(false);
        }
      }
    );
    if (
      counter ===
      (currentProduct as any)?.enrichmentData?.formBuilderAttributesData
        ?.length -
        1
    ) {
      setIsCheckedAll(true);
    }
  };

  const checkboxHandler = (e: any, index: number) => {
    setCheckedValues((prev: any) => ({
      ...prev,
      [index]: e.target.checked,
    }));
  };
  console.log(checkedValues);

  return (
    <div className="col-6 border-end pt-3">
      {!isLoadingTable ? (
        <div className="d-flex justify-content-center">
          <Spinner animation="border" size="sm" role="status" />
        </div>
      ) : (
        <>
          <div
            className="table-responsive"
            style={{ maxHeight: "calc(100vh - 85px)", overflowY: "auto" }}
          >
            <Table className="mb-0 align-middle table-bordered">
              <thead
                className="table-light"
                style={{ position: "sticky", top: 0, zIndex: 2 }}
              >
                <tr>
                  <th scope="col">{t("mapping.attribute")}</th>
                  <th className="p-0" scope="col">
                    <span
                      className="d-block border-bottom"
                      style={{ padding: ".375rem .3rem" }}
                    >
                      {t("global.old_value")}
                    </span>
                    <span
                      className="d-block"
                      style={{ padding: ".375rem .3rem" }}
                    >
                      {t("global.new_value")}
                    </span>
                  </th>
                  <th className="vertical-middle text-center">
                    <input
                      className="m-auto form-check-input m-0 cursor-pointer"
                      checked={isCheckedAll}
                      type="checkbox"
                      onChange={checkAll}
                    />
                  </th>
                </tr>
              </thead>
              {Boolean(
                (currentProduct as any)?.enrichmentData
                  ?.formBuilderAttributesData
              ) && (
                <tbody>
                  {(
                    currentProduct as any
                  )?.enrichmentData?.formBuilderAttributesData?.map(
                    (item: any, index: number) => {
                      return (
                        <tr key={item?.id}>
                          <td
                            className="text-nowrap text-start"
                            style={{
                              backgroundColor: "#f3f6f9",
                              fontWeight: "500",
                            }}
                          >
                            {item?.title}
                          </td>
                          <td className="text-start border-left p-0">
                            <span
                              className="d-block border-bottom"
                              style={{
                                padding: ".75rem .6rem",
                                backgroundColor: "#f7d0d0",
                              }}
                            >
                              {item?.currentValues?.length > 0 &&
                                item?.currentValues
                                  ?.map((current: any) => current?.title)
                                  .join(", ")}
                            </span>
                            <div
                              style={{
                                padding: ".75rem .6rem",
                                backgroundColor: "#e1f7da",
                              }}
                            >
                              <input
                                type="text"
                                className="form-control"
                                value={inputValues[index] || ""}
                                onChange={(e) => {
                                  updateNewAttributeValues(
                                    index,
                                    e.target.value
                                  );
                                }}
                                // placeholder={t(
                                //   "data_enrichment.separate_with_semicolons"
                                // )}
                              />
                            </div>
                          </td>
                          <td className="">
                            <input
                              type="checkbox"
                              className="form-check-input m-0 cursor-pointer"
                              onChange={(e) => checkboxHandler(e, index)}
                              checked={checkedValues[index] || false}
                            />
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              )}
            </Table>
          </div>
        </>
      )}
    </div>
  );
};
